import React from "react";
import { Link } from "react-router-dom";
import useSEO from "../hooks/useSEO";
import { Arrow } from "../components/Icons";

export default function NotFound() {
  useSEO({ title: "Page not found", description: "The page you are looking for does not exist.", path: "/404" });
  return (
    <section className="notfound container">
      <div>
        <h1 className="grad-text">404</h1>
        <p className="lead" style={{ marginInline: "auto" }}>This page is still in the future. Let's get you back to the present.</p>
        <Link to="/" className="btn btn--primary btn--lg" style={{ marginTop: 20 }}>Back to home <Arrow /></Link>
      </div>
    </section>
  );
}
